<div class="row" style="justify-content: space-between; align-items: center">
  <h3 class="titulo">Sindicatos</h3>
  <div style="text-align: center">
    <button class="btn btn-outline-success" (click)="openModalSindicato('new')">
      <i class="fas fa-plus"></i> Novo Sindicato
    </button>
    <button
      class="btn btn-outline-success"
      style="margin: 0px 5px"
      (click)="openModalUpload()"
    >
      <i class="fas fa-file-upload"></i> Upload de Sindicatos
    </button>
  </div>
</div>
<hr />
<div class="d-flex justify-content-end">
  <input
    type="text"
    class="form-control"
    style="width: 400px; border-radius: 14px"
    [(ngModel)]="searchVal"
    placeholder="Buscar Sindicato ou CNPJ"
  />
</div>

<div class="table-responsive" style="padding-top: 10px; padding-bottom: 10px">
  <table>
    <thead>
      <tr>
        <th class="th-rigth-border">CNPJ</th>
        <th class="th-rigth-border" (click)="sortTable('nome')">
          Sindicato
          <i
            class="fas"
            [ngClass]="getSortIcon('nome')"
            style="margin-left: 5px; cursor: pointer"
          ></i>
        </th>
        <th class="th-rigth-border">Status</th>
        <th>Ações</th>
      </tr>
    </thead>
    <tbody *ngIf="sindicatos.length > 0">
      <tr
        *ngFor="
          let sind of filteredSindicatos
            | slice : (paginaAtual - 1) * size : (paginaAtual - 1) * size + size
        "
      >
        <td>{{ sind.cnpj }}</td>
        <td>{{ sind.nome }}</td>
        <td>
          {{ sind.status }}
          <div *ngIf="sind.ativo" class="tag-apro">ATIVO</div>
          <div *ngIf="!sind.ativo" class="tag-repro">INATIVO</div>
        </td>
        <td>
          <div style="display: inline-flex">
            <i
              class="fas fa-search acoes"
              style="padding-left: 5px"
              placement="bottom"
              ngbTooltip="Visualizar"
              (click)="openModalSindicato('view', sind)"
            ></i>
            <i
              class="fas fa-edit acoes"
              style="padding-left: 5px"
              placement="bottom"
              ngbTooltip="Editar"
              (click)="openModalSindicato('edit', sind)"
            ></i>
            <i
              class="fas fa-ban acoes"
              *ngIf="sind.ativo"
              style="padding-left: 5px"
              placement="bottom"
              ngbTooltip="Inativar"
              (click)="changeStatus(sind)"
            ></i>
            <i
              class="fas fa-check acoes"
              *ngIf="!sind.ativo"
              style="padding-left: 5px"
              placement="bottom"
              ngbTooltip="Ativar"
              (click)="changeStatus(sind)"
            ></i>
          </div>
        </td>
      </tr>
    </tbody>
    <p
      *ngIf="filteredSindicatos.length <= 0"
      style="color: #ff0000; font-weight: bold"
    >
      • Não existem sindicatos cadastrados.
    </p>
  </table>
</div>
<div class="row">
  <div class="col-12" style="padding: 0; text-align: right">
    Quantidade de Sindicatos: {{ filteredSindicatos.length }}
  </div>
</div>
<div class="row" style="justify-content: space-between">
  <select
    style="width: fit-content !important"
    class="form-control"
    type="text"
    name="qtdPage"
    id="qtdPage"
    [(ngModel)]="size"
    (change)="changeOp(size)"
  >
    <option *ngFor="let op of opcoes">{{ op }}</option>
  </select>
  <ngb-pagination
    class="d-flex justify-content-end"
    [collectionSize]="filteredSindicatos.length"
    [(page)]="paginaAtual"
    [pageSize]="size"
    [maxSize]="2"
    [rotate]="true"
    [ellipses]="false"
    [boundaryLinks]="false"
    size="sm"
  ></ngb-pagination>
</div>
